import { Label, Icon, Modal, Input } from "semantic-ui-react"
import React, {Component, Fragment} from "react"
import Price from "components/Price/Price"
import OrderModel   from "shop/OrderModel";
import shop from "shop/shop"
import { Button } from "elemental-react16";
import {observer} from "mobx-react"



@observer
export default class ProductPrice extends Component {

	constructor() {
		super()
		this.state = {
      priceEditor: false,
      pricetemp: 0
		}
	}
  render(){

  let {product, priceTemp} = this.props
  let handUserSelfPricingInCart = false;
  let handuserSelfPricingInCartPosition = null;
  if (shop.session.handUser && shop.session.handUser.selfprice && shop.cart.data.positions && shop.cart.data.positions.some(position => position.article_id === product.map_id)) {
    handuserSelfPricingInCartPosition = shop.cart.data.positions.find(position => position.article_id === product.map_id);
    handUserSelfPricingInCart = true;
  }
  return <div className={`ProductPrice pb2 relative lh-solid`}>
    <div className="flex flex-row pb2">
      {product.pinfos.gc_rabatt && <Label className={"giftcardPercent"} color="red">COUPON {product.pinfos.gc_rabatt} %</Label>}
      {/*product.isSale && <Label className={"salePercent"} color="red">{product.salePercent}</Label>*/}

    </div>
    
    {product.isSale && <div>
      {/*<div className="unit_multi black-70 f6 pb2 fw2">Stückpreis</div><br/>*/}
      <div className="f4 red b"><Price>{product.price}</Price> <span className="f5 black-60 fw4 pb1 strike "><Price>{product.pinfos.brutto}</Price></span></div>
      <div className="pb1 black-70 f6 fw2 lh-solid">{product.extras.veextrainfo || translate( "Preis / VE" )}</div>
      <div className="pt1 bt b--black-10 black-70 f6 fw2 lh-solid">{translate( "exkl. MwSt. zzgl. Versandkosten" )}</div>
    </div>}
    
    {!product.isSale &&
    <div className="price  lh-solid  ">
      <div className="f3  b">
      {product.pinfos && product.pinfos.brutto && <Fragment className="f4 red b"><span className="f5 black-60 fw4 pb1 strike ">
        <Price>{handUserSelfPricingInCart && handuserSelfPricingInCartPosition != null && handuserSelfPricingInCartPosition.extras && handuserSelfPricingInCartPosition.extras.customPrice ? handuserSelfPricingInCartPosition.extras.customPrice : product.pinfos.brutto}</Price></span> 
        <br/><span className="red"><Price>{handUserSelfPricingInCart && handuserSelfPricingInCartPosition != null && handuserSelfPricingInCartPosition.extras && handuserSelfPricingInCartPosition.extras.gc_price_brutto ? handuserSelfPricingInCartPosition.extras.gc_price_brutto :  this.state.pricetemp == 0 ? product.price : product.price * ((100 - product.pinfos.gc_rabatt)/100) }</Price></span> </Fragment> }
        {product.pinfos && !product.pinfos.brutto && <Price>{product.price}</Price> }
      {shop.session.handUser && shop.session.handUser.selfprice && 
      <a className="pl3" ><Button 
        
        
        onClick={() => {
          this.setState({ pricetemp: product.price})
          this.setState({ priceEditor: true })
        }}
        ><Icon className=" edit"></Icon></Button></a>}
        <div>
        <Modal className="pl3 pr3"
					closeIcon={<Icon name="close" />}
					open={this.state.priceEditor}
					onClose={() => {
						this.setState( {
              priceEditor: false} )
					}}
					size="tiny"
				>
					<Modal.Header>{translate( "Preisanpassung des Vertreters" )}</Modal.Header>
					<Modal.Content className="pl3">
          <div className="f4 fw5 pb3 pt2">Bitte geben Sie einen neuen Preis ein:</div>
            <table>
              <colgroup>
                <col width="80%"/>
                <col width="20%"/>
              </colgroup>
              <tbody>
                <tr className="bt bb b--black-20">
                  <td className="pt3 pb3"><Input className="pb2 w-20" type="text" value={this.state.pricetemp} onKeyPress={(event) => {
                                if (!/[0-9.]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                        onChange={(e) => {
                          this.setState({pricetemp: e.target.value})}}/><label className="pl2">EUR</label></td>
                  <td className="tr"><Button primary onClick={() => {
                          product.price = Number(this.state.pricetemp)
                          product.pinfos.priceTemp = Number(this.state.pricetemp)
                          priceTemp = Number(this.state.pricetemp)
                          //console.log("product PRICE ADJUST",product, priceTemp)
                          this.setState({
                            priceEditor: false
                          })
                        }}>Speichern</Button></td>
                </tr>
                {product.extras && product.extras.Einkaufspreis && product.extras.Einkaufspreis.value.value && shop.session.handUser && shop.session.handUser.extras && shop.session.handUser.extras.ekpreis &&
                 <tr className="">
                  <td>
                    <div className="pt3 f4 fw4 ">Einkaufspreis: </div>
                  </td>
                  <td>
                    <div className="pt3  tr f4 fw4">{Number(product.extras.Einkaufspreis.value.value).toFixed(2)} EUR</div>
                  </td>
                </tr>}
              </tbody>
            </table>

          </Modal.Content>


					{/*<Modal.Actions>*/}
					{/*/!*<Button positive icon="checkmark" labelPosition="right" content="Yes" />*!/*/}
					{/*</Modal.Actions>*/}
				</Modal>
        </div>
       {product.salePercent &&
      <span className={"black-60 f5 fw4"}>(<Price>{product.originalPrice}</Price> abzgl. {product.salePercent} Rabatt)</span>}
      </div>
      <div className="pb1 black-70 f6 fw2 lh-solid">{product.extras.veextrainfo || translate( "Preis / VE" )}</div>
      <div className="pt1 bt b--black-10 black-70 f6 fw2 lh-solid">{translate( "exkl. MwSt. zzgl. Versandkosten" )}</div>
    </div>}

  </div>
}
}


// WEBPACK FOOTER //
// ./src/theme/hvz/components/Product/ProductPrice.js